// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__2hybR","buttons":"PendingPaymentAlert_buttons__33_H8"};